import axios from 'axios';
import routes from '../routes';
import VueRouter from 'vue-router';
import {
  router
} from '../main.js'
const addinstance=()=>{
var loginType="正式";
var baseURL='https://www.migee.net/platform'
if (sessionStorage.getItem("loginType")){
    loginType=JSON.parse(sessionStorage.getItem('loginType'))
}

if(loginType=="测试"){
  var baseURL='https://test.migee.net/platform'
}
var qs = require('qs');
const instance = axios.create({
  baseURL:baseURL,
  // test
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  transformRequest: [function (data) {
    data = qs.stringify(data);
    return data;
  }],
  withCredentials: true,
  crossDomain: true,
});
// http request 请求拦截器，有token值则配置上token值
instance.interceptors.request.use(
  config => {
      return config;
  },
  err => {
      return Promise.reject(err);
  });

// http response 服务器响应拦截器，这里拦截401错误，并重新跳入登页重新获取token
instance.interceptors.response.use(
  response => {
      if(response.data){
         switch(response.data.code){
           case 2:
           router.push({
             path:'/login' //未登录直接跳转登录
           });
           break;
           case 0:
           return response;
           break;
           case 1:
           return response;
           break;
         }
      }
      // return response;
  },
  error => {
      if (error.response) {
          switch (error.response.status) {
              case 401:
                  router.push({
                      path: 'login',
                  //    query: {redirect: router.currentRoute.fullPath}//登录成功后跳入浏览的当前页面
                  })
          }
      }
      return Promise.reject(error.response.data) 
  });
return instance
}
export default addinstance;



// WEBPACK FOOTER //
// ./src/api/instance.js